// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { ExtendedDatabase } from './extended-types';

const SUPABASE_URL = "https://mqorykrxvqfkifjkveqe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1xb3J5a3J4dnFma2lmamt2ZXFlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE3ODI2MDIsImV4cCI6MjA4NzM1ODYwMn0.4RnBDxzOvF3BdLSylkAGWDHgKaID-dnEvpw1f9h4p-g";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<ExtendedDatabase>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);